import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import {Response} from 'src/app/services/models/response.model'
import { SearchRoleMasterRequestModel } from './models/role/rolemaster.search.request.model';
import { RoleMasterModel } from './models/role/rolemaster.model';


@Injectable()
export class RoleService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.role;
  }
  searchRoleMaster(data: SearchRoleMasterRequestModel): Observable<Response<RoleMasterModel[]>> {
    return this.post(`/SearchRoleMaster`, data, {})
    .map(result => new Response<RoleMasterModel[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }
}